(function () {
  'use strict';

  angular
    .module('web2print')
    .directive('isMobileNumber', isMobileNumber);

  /* @ngInject */
  function isMobileNumber ($parse) {
    const directive = {
      restrict: 'A',
      require: 'ngModel',
      link: linkFunc
    };

    return directive;

    function linkFunc (scope, el, attr, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        const valid = checkNumber(value);
        ctrl.$setValidity('isMobileNumber', valid);
        return valid ? value : undefined;
      });

      ctrl.$formatters.unshift(function (value) {
        const valid = checkNumber(value);
        ctrl.$setValidity('isMobileNumber', valid);
        return value;
      });

      function checkNumber (value) {
        const countryCode = $parse(attr.countryCode)(scope);
        let valid;

        try {
          valid = phoneUtils.getNumberType(value, countryCode) === 'MOBILE';
        } catch (e) {
          valid = !value;
        }

        return valid;
      }
    }
  }
})();
